import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    RegisterModel, LoginModel, ConfirmAccountModel, RecoverAccountModel, ResetAccountModel,
    ChangePasswordModel, ExternalLoginModel, ExternalLoginModelToken
} from '../models/account';
import { AppSettings } from '../helpers';

@Injectable()
export class AccountService {
    constructor(private http: HttpClient,
        private appSettings: AppSettings) { }

    register(model: RegisterModel) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/account', model);
    }

    login(model: LoginModel) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/account/token', model);
    }

    externalLogin(model: ExternalLoginModel) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/account/external-login', model);
    }

    externalLoginToken(model: ExternalLoginModelToken) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/account/external-login-token', model);
    }

    getCurrentUserProfile() {
        return this.http.get(this.appSettings.ApiBaseUrl + '/api/account/get-current-user-profile');
    }

    sendVerificationEmail(userId: string) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/account/send-verification-email', { userId });
    }

    confirmAccount(model: ConfirmAccountModel) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/account/confirm-account', model);
    }

    recoverAccount(model: RecoverAccountModel) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/account/recover-account', model);
    }

    resetAccount(model: ResetAccountModel) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/account/reset-account', model);
    }

    changePassword(model: ChangePasswordModel) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/account/change-password', model);
    }

    changeRole(role: string) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/account/change-role', { role });
    }

    deactivate() {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/account/deactivate', {});
    }
}



// WEBPACK FOOTER //
// ./src/services/account.service.ts